import React, { useState, useContext, useEffect } from 'react';
import Card, { CardBody } from '../../components/bootstrap/Card';
import Page from '../../layout/Page/Page';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import logo from '../../assets/images/brand_dark.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Button from '../../components/bootstrap/Button';
import classNames from 'classnames';
import useDarkMode from '../../hooks/useDarkMode';
import LANG, { getLangWithKey } from '../../lang';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/icon/Icon';
import FormGroup from '../../components/bootstrap/forms/FormGroup';
import Input from '../../components/bootstrap/forms/Input';
import { useFormik } from 'formik';
import InputGroup from '../../components/bootstrap/forms/InputGroup';
import showNotification from '../../components/extras/showNotification';
import UserService from '../../services/UserService';
import { useMst } from '../../models';
import ThemeContext from '../../contexts/themeContext';
import moment from 'moment';
import cardImage from "../../assets/images/test_card.svg";

const Test = (props) => {
    const navigate = useNavigate();
    const { darkModeStatus } = useDarkMode();
    const { t, i18n } = useTranslation(['translation', 'menu']);
    const { user } = useMst();
    const { setNoticeCount, lang, setLang } = useContext(ThemeContext);
    const [visiblePW, setVisiblePW] = useState(false);
    // const { updateUser } = useChannelIOApi(); // 새로운 버전에서 x

    const loginData = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        onSubmit: (values) => {
            if (!values.email || !values.password) {
                showNotification(t('로그인'), t('필수 정보를 확인해주세요.'), 'danger');
            } else {
                requestLogin(values);
            }
        },
    });

    const changeLanguage = (lng) => {
        i18n
            .changeLanguage(lng)
            .then(() => {
                moment.locale(lng);
                showNotification(
                    <span className='d-flex align-items-center'>
                        <Icon icon={getLangWithKey(lng)?.icon} size='lg' className='me-1' />
                        <span>{`${getLangWithKey(lng)?.text}`}</span>
                    </span>,
                    t('You updated the language of the site.')
                );
            })
            .then(() => {
                setLang(lng);
            });
    };

    // 로그인 시 읽지 않은 게시물 카운트
    const readNoticeCount = async () => {
        const noticeCount = await BoardService.readCount('notice', user.me.currentCompanyId);
        setNoticeCount(noticeCount?.data || 0);
    };

    const requestLogin = async (values) => {
        const loginData = await UserService.login(values);
        if (loginData?.message) {
            // 로그인 실패 시
            showNotification(t('로그인'), t(loginData?.message), 'danger');
        } else {
            user
                .authMe()
                .then(async () => {
                    navigate('/dashboard')
                })
                .catch((e) => {
                    console.log(e);
                    showNotification(t('로그인'), t('로그인에 실패하였습니다.') + t('다시 확인해주세요') + '.', 'danger');
                });
        }
    };

    return (
        <PageWrapper  title={'Test'}>
            <div className='test-bg'></div>
            <Page >
                <div className='row h-100 align-items-center justify-content-center'>
                    <div className='col-xl-4 col-sm-4 text-center'>
                        <div className='font font-20'>ICRU 기질진단</div>
                        <div className='font font-14 white mt-30'>
                            지금부터 ICRU기질진단을 시작합니다.<br />
                            총 18항목으로 구성되어 있으며 소요 시간은 약 10분입니다.<br />
                            모든 질문과 결과에는 좋고 나쁨이 없습니다.<br />
                            스스로에게 솔직하게 답변해 주세요.
                        </div>
                        <img className='mt-30' src={cardImage} alt="진단시작" />
                        <div className='w-100 text-center mt-5'>
                            <Button
                                id='login-btn'
                                style={{
                                    width: '243px',
                                    height: '45px',
                                    padding: '0px',
                                    gap: '12.25px',
                                    borderRadius: '81.68px',
                                    fontFamily: 'Pretendard',
                                    fontSize: '17.97px',
                                    fontWeight: 500,
                                    textAlign: 'center',
                                }}
                                color='success'
                                type='submit'
                                onClick={() => {
                                    navigate('/question')
                                }}>
                                {t('진단 시작')}
                            </Button>
                        </div>
                    </div>
                </div>
            </Page>
        </PageWrapper>
    );
};
export default Test;
